module.exports = __webpack_public_path__ + "img/symbol_3.528a4154.png";